import ourPeople from '../modules/our-people';

export default {
    init() {},
    finalize() {
        ourPeople();
    },
};
